import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import { KENDO_LAYOUT } from '@progress/kendo-angular-layout';
import version from '@unity/assets/version.json';
import backgrounds from '@unity/public/bg-manifest.json';

@Component({
  selector: 'unity-outside-container',
  standalone: true,
  imports: [KENDO_LAYOUT, CommonModule, NgOptimizedImage],
  templateUrl: './outside-container.component.html',
  styleUrl: './outside-container.component.scss',
})
export class OutsideContainerComponent {
  protected version = version;
  protected backgroundImageUrl = this.getRandomBackground();

  public readonly $modalHeaderTitle = input('Unity', { alias: 'modalHeaderTitle' });
  public readonly $modalHeaderSubtitle = input('Welcome to', { alias: 'modalHeaderSubtitle' });

  private getRandomBackground(): string {
    const randomIndex = Math.floor(Math.random() * backgrounds.length);
    return backgrounds[randomIndex];
  }
}
